import { useMutation, useQueryClient } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';
import type { CMChecklistManualOverride, CMChecklistManualOverrideUpsert } from '~/services/OffersService';

import { patchCMChecklistEvaluationOverride } from './useCMChecklistEvaluation';

export function useUpsertCMChecklistManualOverride(offerId: string | undefined) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CMChecklistManualOverrideUpsert) => {
      if (!offerId) {
        throw new Error('offerId is required');
      }

      const response = await OffersService.upsertCMChecklistManualOverride(offerId, payload);
      return response.result as CMChecklistManualOverride;
    },
    onSuccess: (manualOverride) => {
      patchCMChecklistEvaluationOverride(queryClient, offerId, manualOverride);
    },
  });
}
